<template>
  <div class="index-item">
    <div v-if="itemArr.length !== 0">
      <div class="item-card" v-for="(item, index) in itemArr" :key="index" @click="lookDetail(item.orgcode,item.orgname)">
        <div class="card-left">
          <div >{{item.orgname}}</div>
          <div >{{item.orgcode}}</div>
        </div>
        <div class="card-icon"></div>
      </div>
    </div>
    <div v-else class="item-null">
        暂无收银数据
    </div>
    
    <!-- 收款方式选择弹窗 -->
    <van-popup v-model="showPaymentModal" position="center" class="payment-modal" >
      <div class="modal-content">
        <div class="modal-title">请选择收款方式</div>
        <div class="modal-buttons">
          <!-- <span v-if="classifyAuth==1">
            <van-button  type="primary" class="payment-btn" @click="goToPayment('amount')">
              按金额收款
            </van-button>
            <van-button  type="primary" class="payment-btn" @click="goToPayment('quantity')">
              按数量收款
            </van-button>
          </span> -->
          <span>
            <van-button v-if="stationOilUnit == 1" type="primary" class="payment-btn" @click="goToPayment('amount')">
              按金额收款
            </van-button>
            <van-button v-else type="primary" class="payment-btn" @click="goToPayment('quantity')">
              按数量收款
            </van-button>
          </span>
          
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { goodsBaseApi } from '@/api/station';
import { Toast } from 'vant';
import { mapGetters, mapActions } from 'vuex';
import { MODIFY_USETIP } from '@/store/appconf';
export default {
  name: 'CooperativeIndexItem',
  components: {},

  props: {
    stationOilUnit: {
      type: String,
      require: true,
    },
    classifyAuth: {
      type: String,
      require: true,
    },
    itemArr : {
      type: Array,
      require: true,
      default: function () {
        return [];
      }
    },
  },
  data() {
    return {
      showPaymentModal: false,
      station_id: '',
      orgName: '',
      token: '',
      currentOrderId: '',
      currentOrderStatus: ''
    }
  },
  mounted(){
    const {station_id,token} = JSON.parse(localStorage.getItem('g7user'))
    this.station_id = station_id
    this.token = token
  },
  methods:{
    lookDetail(orgCode,orgName){
      // 保存当前订单信息
      this.orgName = encodeURIComponent(orgName)
      this.orgCode = orgCode
      
      // 显示收款方式选择弹窗
      this.showPaymentModal = true
    },
    goToPayment(paymentType) {
      // 关闭弹窗
      this.showPaymentModal = false
      // 跳转到收款页面，带上收款方式参数
      this.$router.push({
        path: '/PaymentCollection',
        query: {
          payment_type: paymentType, // 'quantity' 或 'amount'
          orgName: this.orgName,
          orgCode: this.orgCode
        }
      })
    },
    // getGoodsBaseAjax(){
    //   let params = {
    //     station_id: this.station_id,
    //     order_token: Store.state.user.user.token
    //   }
    //   goodsBaseApi(params).then(res=>{
    //     if (res.code === 0 ){
    //         this.GET_STATIONINFO.stationOilUnit == 1 ? this.cur_mode = 'amount' : this.cur_mode = 'number'
    //         this.goodsList = res.data.goods
    //         this.goodsOtherObj = res.data
    //         if(this.goodsOtherObj.is_access_platform_driver == 1){
    //             Toast('该订单不支持收款')
    //             this.showPaymentModal = false
    //             return
    //         }
    //         if (this.GET_STATIONINFO.classifyAuth && this.GET_STATIONINFO.classifyAuth == 1 && this.GET_USETIP){
    //           this.showPaymentModal = true
    //         }
    //     }else{
    //       Toast(res.msg)
    //     }
    //   }).catch(err => {
    //     console.log(err.message)
    //   })
    // },
  },
  watch: {
    // 监听 stationOilUnit 的变化
    stationOilUnit: {
      handler(newVal, oldVal) {
        console.log(`[${new Date().toLocaleTimeString()}] stationOilUnit 变化:`, {
          old: oldVal,
          new: newVal,
          type: typeof newVal
        });
        // 可以根据需要在这里做一些响应处理
        if (newVal !== oldVal && newVal !== undefined && newVal !== null) {
          this.stationOilUnit = newVal
          console.log('stationOilUnit 数据已更新，当前收款方式:', newVal === 1 ? '按金额收款' : '按数量收款');
        }
      },
      immediate: true
    },
    // 监听 classifyAuth 的变化
    classifyAuth: {
      handler(newVal, oldVal) {
        console.log(`[${new Date().toLocaleTimeString()}] classifyAuth 变化:`, {
          old: oldVal,
          new: newVal,
          type: typeof newVal
        });
        // 可以根据需要在这里做一些响应处理
        if (newVal !== oldVal && newVal !== undefined && newVal !== null) {
          this.classifyAuth = newVal
          console.log('classifyAuth 数据已更新，切换权限:', newVal === 1 ? '允许切换' : '不允许切换');
        }
      },
      immediate: true
    }
  },
  computed: {

  },
}
</script>

<style scoped lang="less">
  .index-item{
    height: 272px;
    padding: 15px;
    .item-card{
      display: flex;
      //align-items: center;
      height: 109px;
      background-color: #fff;
      box-shadow: 0 5px 12px 0 rgba(83, 47, 230, 0.12);
      border-radius: 6px;
      margin-bottom: 15px;
      padding: 15px 10px 15px 15px;
      color: #555;
      font-size: 14px;

      .card-left{
        flex: 1;
        div:first-child {
          height: 25px;
          line-height: 25px;
          font-size: 18px;
          font-weight: 600;

        }
        div:nth-child(2) {
          margin-top: 7px;
          height: 20px;
          line-height: 20px;
          color: #555;
          font-size: 14px;
        }
        div:nth-child(3) {
          margin-top: 7px;
          height: 20px;
          line-height: 20px;
          color: #888;
        }
        .text-orange{
          color: #F84728
        }
        .text-green{
          color: #64C45C
        }
      }
      .card-right{
        text-align: right;
        margin-right: 10px;
        div:first-child {
          height: 25px;
          line-height: 25px;
          color: #333;
          font-size: 18px;
          font-weight: 600;

        }
        div:nth-child(2) {
          margin-top: 7px;
          height: 20px;
          line-height: 20px;
          color: #555;
          font-size: 14px;
        }
      }
      .card-icon{
        height: 12.5px;
        width: 7.5px;
        margin-top: 25px;
        background: url(../assets/arrow-right@2x.png) no-repeat;
        background-size: 100%;
      }

    }
    .item-null{
      color: #888888;
      font-size: 15px;
      text-align: center;
      line-height: 250px;
    }
  }
  
  // 弹窗样式
  .payment-modal {
    .modal-content {
      width: 300px;
      background: #fff;
      border-radius: 10px;
      padding: 30px 20px;
      text-align: center;
      
      .modal-title {
        font-size: 16px;
        font-weight: 500;
        color: #333;
        margin-bottom: 30px;
      }
      
      .modal-buttons {
        .payment-btn {
          width: 100%;
          height: 50px;
          margin-bottom: 15px;
          background: #007AFF;
          border: none;
          border-radius: 8px;
          font-size: 16px;
          font-weight: 500;
          
          &:last-child {
            margin-bottom: 0;
          }
        }
        
        .back-index {
          width: 100%;
          height: 44px;
          margin-top: 20px;
          background: #f5f5f5;
          color: #666;
          border: 1px solid #e0e0e0;
          border-radius: 8px;
          font-size: 14px;
        }
      }
    }
  }
</style>

<style>
  .payment-modal.van-popup--center {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .payment-modal .van-overlay {
    background: rgba(0, 0, 0, 0.5);
  }
  
  .payment-modal .van-button--primary {
    background: #007AFF !important;
    border-color: #007AFF !important;
  }
</style>
